import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class DepartmentService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/departman/get-list`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new DepartmentService();
